// extracted by mini-css-extract-plugin
export default {"container":"ScaleBalance_container__5EgCh","innerLeft":"ScaleBalance_innerLeft__ibiDm","base":"ScaleBalance_base__eCPiW","baseImg":"ScaleBalance_baseImg__bVs1A"};